module.exports = __webpack_public_path__ + "static/media/clap.2f4073e3.gif";